import { Box, IconButton, useTheme, Tooltip, Menu, MenuItem, Typography, Badge } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { AuthContext } from '../../context/AuthContext';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import MessageIcon from '@mui/icons-material/Message'; // New icon for messages
import VisibilityIcon from '@mui/icons-material/Visibility'; // New icon for profile views
import PersonAddIcon from '@mui/icons-material/PersonAdd'; // New icon for new followers

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const { currentuser, logout } = useContext(AuthContext);
  const [user, setUser] = useState(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);

  const notifications = [
    { id: 1, message: "New message from John", icon: <MessageIcon /> },
    { id: 2, message: "Your profile was viewed", icon: <VisibilityIcon /> },
    { id: 3, message: "You have a new follower", icon: <PersonAddIcon /> },
  ];

  const userSetter = () => {
    setUser(currentuser?.userData);
  };

  useEffect(() => {
    userSetter();
  }, [currentuser]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationMenu = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  return (
    <Box display="flex" justifyContent="flex-end" p={2} bgcolor={colors.primary.main}
      sx={{
        mx: 2,
          background: `${colors.primary[500]} !important`,
      }}
    >
      <Box display="flex" alignItems="center">
        {/* Notifications Icon with Badge */}
        <Tooltip title="Notifications">
          <IconButton onClick={handleNotificationMenu} sx={{ marginRight: 2 }}>
            <Badge badgeContent={notifications.length} color="primary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={notificationAnchorEl}
          open={Boolean(notificationAnchorEl)}
          onClose={handleNotificationClose}
          PaperProps={{
            style: {
              width: '250px',
              backgroundColor: 'white',
            },
          }}
        >
          {notifications.map((notification) => (
            <MenuItem key={notification.id} onClick={handleNotificationClose}
              sx={{ color: 'black', '&:hover': { backgroundColor: '#f0f0f0' } }}
            >
              {notification.icon}
              <span style={{ marginLeft: 8 }}>{notification.message}</span>
            </MenuItem>
          ))}
        </Menu>

        {/* User Name */}
        <Typography sx={{ marginRight: 2, color: 'white' }}>
          {user?.firstname} {user?.lastname}
        </Typography>

        {/* Profile Icon and Menu */}
        <div>
          <Tooltip title="My Profile">
            <IconButton onClick={handleMenu}>
              <PersonOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              style: {
                width: '300px',
                backgroundColor: 'white',
                marginTop: 40
              },
            }}
          >
            <MenuItem
              onClick={() => { alert('Profile clicked'); }}
              sx={{ color: 'black', '&:hover': { backgroundColor: '#f0f0f0' } }}
            >
              <AccountCircleIcon sx={{ marginRight: 1 }} />
              Profile
            </MenuItem>
            <MenuItem
              onClick={() => { alert('My account clicked'); }}
              sx={{ color: 'black', '&:hover': { backgroundColor: '#f0f0f0' } }}
            >
              <PersonOutlinedIcon sx={{ marginRight: 1 }} />
              My account
            </MenuItem>
            <MenuItem
              onClick={logout}
              sx={{ color: 'black', '&:hover': { backgroundColor: '#f0f0f0' } }}
            >
              <ExitToAppIcon sx={{ marginRight: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </div>
      </Box>
    </Box>
  );
};

export default Topbar;